import ChangeLogDialog from '../../../shared/change-log-dialog';
import { CalendarRoles } from '../../../utils/roles/client-roles';
import { useChangeLogGate } from '../../../shared/hooks/use-change-log-gate';
import ResourceCalendarShareDialog from './resource-calendars-share-dialog';
import { Dispatch, SetStateAction } from 'react';
import { ResourceCalendar } from '../../../../types';

interface ResourceCalendarShareGatedDialogProps {
  open: boolean;
  handleClose: () => void;
  selectedCalendar: ResourceCalendar;
  setSelectedCalendar: Dispatch<SetStateAction<ResourceCalendar | null>>;
  calendarRoles: string[];
  changeLogRoles: string[];
  primaryDomain: string;
  loggedInUser: string;
}

export default function ResourceCalendarShareGatedDialog({
  open,
  handleClose,
  selectedCalendar,
  setSelectedCalendar,
  calendarRoles,
  changeLogRoles,
  primaryDomain,
  loggedInUser,
}: ResourceCalendarShareGatedDialogProps) {
  const changeLogGateView = useChangeLogGate({
    permissionValue: CalendarRoles.ViewResourceCalendarShares.value,
    changeLogRoles,
  });

  function handleCloseAndReset() {
    changeLogGateView.reset();
    handleClose();
    setSelectedCalendar(null);
  }

  if (
    changeLogGateView.needsChangeLog &&
    !changeLogGateView.confirmedChangeLogMessage.trim()
  ) {
    return (
      <ChangeLogDialog
        open={open}
        handleClose={handleCloseAndReset}
        changeLogMessage={changeLogGateView.changeLogMessage}
        setChangeLogMessage={changeLogGateView.setChangeLogMessage}
        mutate={() => {
          changeLogGateView.confirm();
        }}
        mutateLoading={false}
      />
    );
  }

  return (
    <ResourceCalendarShareDialog
      open={open}
      handleClose={handleCloseAndReset}
      selectedCalendar={selectedCalendar}
      setSelectedCalendar={setSelectedCalendar}
      calendarRoles={calendarRoles}
      changeLogRoles={changeLogRoles}
      viewChangeLogMessage={changeLogGateView.confirmedChangeLogMessage}
      primaryDomain={primaryDomain}
      loggedInUser={loggedInUser}
    />
  );
}
